import { UserProfileButton } from './UserProfileButton'
import { useAccount } from '@/domain/hooks/useAccount'
import { ChevronsLeft } from 'lucide-react'
import { useSideDrawer } from '@/domain/hooks/useSideDrawer'
import { ConnectButton, navWalletButtonStyles } from './ConnectButton'

export function WalletButton() {
  const address = useAccount()
  const { open } = useSideDrawer()

  return address ? (
    <UserProfileButton onClick={open} address={address} className={navWalletButtonStyles()} Icon={ChevronsLeft} />
  ) : (
    <ConnectButton source="header">Connect</ConnectButton>
  )
}
